import styled, { keyframes, css } from "styled-components";

export const SWAP_DURATION_MS = 750;

const slideFadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const slideFadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

export const SwapStage = styled.span`
  white-space: nowrap;

  ${({ $align }) =>
    $align === "center"
      ? css`
          display: inline-grid;
          align-items: center;
          justify-items: center;
        `
      : css`
          position: relative;
          display: inline-flex;
          align-items: center;
        `}
`;

export const SwapFace = styled.span`
  display: inline-flex;
  align-items: center;
  animation: ${({ $exiting }) => ($exiting ? slideFadeOut : slideFadeIn)}
    ${SWAP_DURATION_MS}ms ${({ theme }) => theme.easing.entering} forwards;

  ${({ $align, $exiting }) => {
    if ($align === "center") {
      // both faces occupy the same cell so they overlap and stay co-centered
      return css`
        grid-area: 1 / 1;
      `;
    }
    if ($exiting) {
      return css`
        position: absolute;
        top: 0;
        left: 0;
      `;
    }
    return null;
  }}

  ${({ $exiting }) =>
    $exiting &&
    css`
      pointer-events: none;
    `}
`;
